export type Json = string | number | boolean | null | Json[] | { [key: string]: Json };

export const isJson = (value: unknown): value is Json => {
  if (value === null) return true;
  if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') return true;
  if (Array.isArray(value)) return value.every(isJson);
  if (typeof value !== 'object') return false;
  return Object.values(value).every(isJson);
};

export const parseJson = (raw: string): Json => {
  const value: unknown = JSON.parse(raw);
  if (!isJson(value)) throw new SyntaxError('Invalid JSON value');
  return value;
};

export const isJsonObject = (value: unknown): value is { [key: string]: Json } =>
  value != null && isJson(value) && typeof value === 'object' && !Array.isArray(value);
